import React, { useEffect, useState } from 'react';
import './CommunityPosts.scss';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { http, FxSelect, localstorage } from '../../fx-core';
import { NoRecords } from '../../NoRecords/NoRecords';

const CommunityPosts = (props) => {

    let defaultFilter: any = {
        communityId: props.communityId
    };

    const [posts, setPosts] = useState([]);
    const [filters, setFilters] = useState(defaultFilter);
    const [communityList, setCommunityList] = useState([]);

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        let filterObj = {
            communityId: filters.communityId
        }
        if (item.name == 'communityId') {
            filterObj.communityId = item.value;
        }
        getCommunityPosts(filterObj);
    };

    const handleFilterChange = (data) => {
        setFilters(prevState => {
            return { ...prevState, ...data }
        });
    };

    const getMyRegionCommunities = () => {
        let inputData = {
            lookups: {
                MyRegionCommunities: { default: false }
            },
            filters: {
                userId: localstorage.getItem("userId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            getMyRegionCommunitiesCallBack(response);
        })
    };

    const getMyRegionCommunitiesCallBack = (res) => {
        let result = res.data;
        setCommunityList(result.MyRegionCommunities);
    };

    const getMyZoneCommunities = () => {
        let inputData = {
            lookups: {
                MyZoneCommunities: { default: false }
            },
            filters: {
                userId: localstorage.getItem("userId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            getMyZoneCommunitiesCallBack(response);
        })
    }

    const getMyZoneCommunitiesCallBack = (res) => {
        let result = res.data;
        setCommunityList(result.MyZoneCommunities);
    };

    const getMyAdminCommunities = () => {
        let apiOptions: any = {
            url: 'community/role/list',
            data: {}
        };
        http.post(apiOptions).then(res => { getMyAdminCommunitiesCallBack(res) });
    };

    const getMyAdminCommunitiesCallBack = (res) => {
        let result = res.data;
        let commuArr: any = [];
        for (let item of result) {
            let itemObj: any = {
                id: item.id,
                text: item.name
            };
            commuArr.push(itemObj);
        }
        setCommunityList(commuArr);
    };

    const initCalls = () => {
        if (props.parent == 'REGIONALMANAGER') {
            getMyRegionCommunities();
        }
        else if (props.parent == 'ZONALMANAGER') {
            getMyZoneCommunities();
        }
        else if (props.parent == 'COMMADMIN') {
            getMyAdminCommunities();
        }
    }

    const getCommunityPosts = (data) => {
        let inputData = {
            ds: {
                resultset: [
                    { key: "posts", type: "list" }
                ]
            },
            data: {
                communityId: data.communityId
            }
        };
        let apiOptions: any = {
            url: `general/dbo/GetCommunityUserPosts`,
            data: inputData
        };
        http.post(apiOptions).then(res => {
            getCommunityPostsCallBack(res);
        });
    };

    const getCommunityPostsCallBack = (res) => {
        let result = res.data;
        setPosts(result.posts);
    }

    useEffect(() => {
        initCalls();
        getCommunityPosts(filters);
    }, []);

    return (
        <div className='communityposts-ui'>
            <div className='content-container'>
                <div className="content">
                    <div className='row my-4 mx-2'>
                        <div className='col-3'>
                            <FxSelect name="communityId" variant="outlined"
                                label="Community"
                                options={communityList}
                                selectedValue={filters.communityId}
                                valueField="id"
                                displayField="text"
                                size="small"
                                style={{ width: 260 }}
                                onValueChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='row my-4 mx-4 pt-2'>
                        <TableContainer component={Paper}>
                            <Table className="table-striped" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width="15%">Title</TableCell>
                                        <TableCell width="10%">Community</TableCell>
                                        <TableCell width="25%">Short Description</TableCell>
                                        <TableCell width="30%">Long Description</TableCell>
                                        <TableCell width="10%">Provider</TableCell>
                                        <TableCell width="10%">Payment</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        posts.length == 0 &&
                                        <TableCell colSpan={6}>
                                            <NoRecords />
                                        </TableCell>
                                    }
                                    {
                                        posts.length > 0 && posts.map((row: any, i) => (
                                            <TableRow key={i}>
                                                <TableCell>
                                                    {row.title}
                                                    {row.isListingInCommkit &&
                                                        <span className='commkit-wrapper ml-2'>
                                                            <span className="commkit-style px-1">Localites</span>
                                                        </span>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {row.communityName}
                                                </TableCell>                                                
                                                <TableCell>
                                                    {row.shortDescription}
                                                </TableCell>
                                                <TableCell>
                                                    {row.longDescription}
                                                </TableCell>
                                                <TableCell>
                                                    {row.providerName}
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        row.isPaid &&
                                                        <span>Paid</span>
                                                    }
                                                    {
                                                        !row.isPaid &&
                                                        <span>Pending</span>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CommunityPosts;